<template>
  <b-card class="page-view-table">
    <div
      v-if="!reportSettings"
    >
      <!-- search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              @input="handleSearch"
            />
          </div>
        </b-form-group>
      </div>
      <!-- tables -->
      <vue-good-table
        :columns="columns"
        :rows="reports"
        :rtl="direction"
        style-class="vgt-table reports-table"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
          searchFn: searchTable,
        }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
        @on-sort-change="onSortChange"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span
            v-if="props.column.field === 'title'"
          >
            <b-link @click="reportSelected(props.row)">{{ props.formattedRow[props.column.field] }}</b-link>
          </span>
          <span
            v-else
          >
            {{ props.formattedRow[props.column.field] }}
          </span>

        </template>

        <!-- pagination -->
        <template
          slot="pagination-bottom"
          slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">

            <!-- page length -->
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Showing 1 to
              </span>
              <b-form-select
                v-model="pageLength"
                :options="pages"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>

            <!-- pagination -->
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
    <div
      v-else
    >
      <div class="d-flex justify-content-between">
        <div class="report-header">
          <h1>{{ reportSettings.title }}</h1>
          <p>{{ reportSettings.description }}</p>
        </div>
        <div>
          <b-button
            variant="dark"
            class="btn-icon button-close"
            @click="closeReport"
          >
            <feather-icon
              icon="XIcon"
              size="12"
              class="text-muted cursor-pointer"
            />
          </b-button>
        </div>

      </div>
      <div
        v-for="(report, i) in reportSettings.reports"
        :key="`report-${i}`"
        class="button-close"
        @closeReport="closeReport"
      >
        <div />
        <report
          :settings="report"
          :report-data="getReportData(i)"
          :on-progress="getReportDataOnProgress(i)"
        />
      </div>

    </div>
  </b-card>

</template>

<script>
import {
    BCard, BPagination, BFormGroup, BFormInput, BFormSelect, VBTooltip, BLink, BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import store from '@/store'
import { getCoreApiData, getCoreApiDataOnProgress } from '@/coreApi/coreApi'
import coreApiDataIndex from '@/coreApi/coreApiDataIndex'
import { executeQuery } from '@/coreApi/coreApiDataset'
import { getProjectCoreProjectId } from '@/coreApi/filters/coreApiFilterHelper'
import Report from '@/views/components/reports/Report.vue'
import { coreApiDetailFilterObject } from '@/coreApi/filters/coreApiDetailFilter'
import { coreApiPageDateFilterObject } from '@/coreApi/filters/coreApiPageDateFilter'
import { coreApiPageDateRangeFilterObject } from '@/coreApi/filters/coreApiPageDateRangeFilter'
import { coreApiPageWeekFilterObject } from '@/coreApi/filters/coreApiPageWeekFilter'
import { coreApiPageMonthFilterObject } from '@/coreApi/filters/coreApiPageMonthFilter'

export default {
    components: {
        BButton,
        Report,
        BCard,
        VueGoodTable,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BLink,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        const projectId = getProjectCoreProjectId()
        let projectBaseId = projectId
        if (projectBaseId.indexOf('-') > -1) {
            projectBaseId = projectBaseId.slice(0, projectBaseId.indexOf('-'))
        }
        const limitBig = 2000
        const limitSmall = 200
        const timeOut = 559
        const reports = [
            {
                title: 'Editör Raporu - Haftalık',
                description: '(Yazarların, sadece seçilen hafta içinde ürettikleri içeriklerin adet, trafik kaynağı ve KPI verilerini gösterir.)',
                queryAlias: 'reportAuthorSeoWeekly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportAuthorSeoWeekly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'weekly',
                                options: [
                                    {
                                        alias: 'reportAuthorSeoWeekly',
                                        type: 'limit',
                                        limit: limitBig,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                    {
                                        alias: 'reportAuthorSeoWeekly',
                                        type: 'filter_values',
                                        filterKey: 'weekStartDate',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'author',
                                label: 'Author',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'organic',
                                label: 'Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceOrganic',
                                label: 'Source Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'direct',
                                label: 'Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDirect',
                                label: 'Source Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'referral',
                                label: 'Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceReferral',
                                label: 'Source Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'social',
                                label: 'Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSocial',
                                label: 'Source Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'discover',
                                label: 'Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDiscover',
                                label: 'Source Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleNews',
                                label: 'Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleNews',
                                label: 'Source Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleCpc',
                                label: 'Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleCpc',
                                label: 'Source Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'siteInternal',
                                label: 'Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSiteInternal',
                                label: 'Source Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Editör Raporu - Aylık',
                description: '(Yazarların, sadece seçilen ay içinde ürettikleri içeriklerin adet, trafik kaynağı ve KPI verilerini gösterir.)',
                queryAlias: 'reportAuthorSeoMonthly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportAuthorSeoMonthly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'monthly',
                                options: [
                                    {
                                        alias: 'reportAuthorSeoMonthly',
                                        type: 'limit',
                                        limit: limitBig,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                    {
                                        alias: 'reportAuthorSeoMonthly',
                                        type: 'filter_values',
                                        filterKey: 'monthStartDate',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'author',
                                label: 'Author',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'organic',
                                label: 'Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceOrganic',
                                label: 'Source Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'direct',
                                label: 'Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDirect',
                                label: 'Source Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'referral',
                                label: 'Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceReferral',
                                label: 'Source Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'social',
                                label: 'Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSocial',
                                label: 'Source Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'discover',
                                label: 'Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDiscover',
                                label: 'Source Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleNews',
                                label: 'Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleNews',
                                label: 'Source Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleCpc',
                                label: 'Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleCpc',
                                label: 'Source Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'siteInternal',
                                label: 'Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSiteInternal',
                                label: 'Source Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'İçerik Raporu - Haftalık',
                description: '(İçeriklerin, sadece seçilen hafta içinde ürettikleri pv, trafik kaynağı ve KPI verilerini gösterir.)',
                queryAlias: 'reportContentSeoWeekly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportContentSeoWeekly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'weekly',
                                options: [
                                    {
                                        alias: 'reportContentSeoWeekly',
                                        type: 'limit',
                                        limit: limitBig,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'pageViews',
                                        type: 'filter_date_indicator',
                                    },
                                    {
                                        alias: 'reportContentSeoWeekly',
                                        type: 'filter_values',
                                        filterKey: 'weekStartDate',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'pageUrlCleanNoProtcol',
                                label: 'URL',
                            },
                            {
                                field: 'author',
                                label: 'Author',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'organic',
                                label: 'Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceOrganic',
                                label: 'Source Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'direct',
                                label: 'Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDirect',
                                label: 'Source Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'referral',
                                label: 'Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceReferral',
                                label: 'Source Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'social',
                                label: 'Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSocial',
                                label: 'Source Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'discover',
                                label: 'Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDiscover',
                                label: 'Source Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleNews',
                                label: 'Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleNews',
                                label: 'Source Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleCpc',
                                label: 'Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleCpc',
                                label: 'Source Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'siteInternal',
                                label: 'Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSiteInternal',
                                label: 'Source Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            // {
                            //      field: 'datePublished',
                            //      label: 'Date Published',
                            //      valueFormat: 'datetimeHumanReadable',
                            //  },
                        ],
                    },
                ],
            },
            {
                title: 'İçerik Raporu - Aylık',
                description: '(İçeriklerin, sadece seçilen ay içinde ürettikleri pv, trafik kaynağı ve KPI verilerini gösterir.)',
                queryAlias: 'reportContentSeoMonthly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportContentSeoMonthly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'monthly',
                                options: [
                                    {
                                        alias: 'reportContentSeoMonthly',
                                        type: 'limit',
                                        limit: limitBig,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'pageViews',
                                        type: 'filter_date_indicator',
                                    },
                                    {
                                        alias: 'reportContentSeoMonthly',
                                        type: 'filter_values',
                                        filterKey: 'monthStartDate',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'pageUrlCleanNoProtcol',
                                label: 'URL',
                            },
                            {
                                field: 'author',
                                label: 'Author',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'organic',
                                label: 'Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceOrganic',
                                label: 'Source Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'direct',
                                label: 'Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDirect',
                                label: 'Source Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'referral',
                                label: 'Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceReferral',
                                label: 'Source Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'social',
                                label: 'Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSocial',
                                label: 'Source Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'discover',
                                label: 'Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDiscover',
                                label: 'Source Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleNews',
                                label: 'Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleNews',
                                label: 'Source Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleCpc',
                                label: 'Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleCpc',
                                label: 'Source Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'siteInternal',
                                label: 'Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSiteInternal',
                                label: 'Source Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            // {
                            //      field: 'datePublished',
                            //      label: 'Date Published',
                            //      valueFormat: 'datetimeHumanReadable',
                            //  },
                        ],
                    },
                ],
            },
            {
                title: 'İçerik Raporu - Tüm Sayfalar - Haftalık',
                description: '(İçeriklerin, sadece seçilen hafta içinde ürettikleri pv, trafik kaynağı ve KPI verilerini gösterir.)',
                queryAlias: 'reportAllContentSeoWeekly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportAllContentSeoWeekly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'weekly',
                                options: [
                                    {
                                        alias: 'reportAllContentSeoWeekly',
                                        type: 'limit',
                                        limit: limitBig,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'pageViews',
                                        type: 'filter_date_indicator',
                                    },
                                    {
                                        alias: 'reportAllContentSeoWeekly',
                                        type: 'filter_values',
                                        filterKey: 'weekStartDate',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'pageUrlCleanNoProtcol',
                                label: 'URL',
                            },
                            {
                                field: 'author',
                                label: 'Author',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'organic',
                                label: 'Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceOrganic',
                                label: 'Source Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'direct',
                                label: 'Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDirect',
                                label: 'Source Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'referral',
                                label: 'Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceReferral',
                                label: 'Source Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'social',
                                label: 'Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSocial',
                                label: 'Source Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'discover',
                                label: 'Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDiscover',
                                label: 'Source Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleNews',
                                label: 'Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleNews',
                                label: 'Source Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleCpc',
                                label: 'Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleCpc',
                                label: 'Source Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'siteInternal',
                                label: 'Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSiteInternal',
                                label: 'Source Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'videoIds',
                                label: 'videoIds',
                            },
                            // {
                            //      field: 'datePublished',
                            //      label: 'Date Published',
                            //      valueFormat: 'datetimeHumanReadable',
                            //  },
                        ],
                    },
                ],
            },
            {
                title: 'İçerik Raporu - Tüm Sayfalar - Aylık',
                description: '(İçeriklerin, sadece seçilen ay içinde ürettikleri pv, trafik kaynağı ve KPI verilerini gösterir.)',
                queryAlias: 'reportAllContentSeoMonthly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportAllContentSeoMonthly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'monthly',
                                options: [
                                    {
                                        alias: 'reportAllContentSeoMonthly',
                                        type: 'limit',
                                        limit: limitBig,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'pageViews',
                                        type: 'filter_date_indicator',
                                    },
                                    {
                                        alias: 'reportAllContentSeoMonthly',
                                        type: 'filter_values',
                                        filterKey: 'monthStartDate',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'pageUrlCleanNoProtcol',
                                label: 'URL',
                            },
                            {
                                field: 'author',
                                label: 'Author',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'organic',
                                label: 'Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceOrganic',
                                label: 'Source Organic',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'direct',
                                label: 'Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDirect',
                                label: 'Source Direct',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'referral',
                                label: 'Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceReferral',
                                label: 'Source Referral',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'social',
                                label: 'Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSocial',
                                label: 'Source Social',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'discover',
                                label: 'Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceDiscover',
                                label: 'Source Discover',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleNews',
                                label: 'Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleNews',
                                label: 'Source Google News',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'googleCpc',
                                label: 'Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceGoogleCpc',
                                label: 'Source Google Cpc',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'siteInternal',
                                label: 'Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'sourceSiteInternal',
                                label: 'Source Site Internal',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'videoIds',
                                label: 'videoIds',
                            },
                            // {
                            //      field: 'datePublished',
                            //      label: 'Date Published',
                            //      valueFormat: 'datetimeHumanReadable',
                            //  },
                        ],
                    },
                ],
            },
            {
                title: 'Yazar İçerik Adet İstatistikleri - Haftalık',
                description: 'Yazarların, sadece seçilen hafta içinde ürettikleri içeriklerin adet ve okunma sayılarını gösterir.',
                queryAlias: 'reportAuthorWeeklyQuantity',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportAuthorWeeklyQuantity',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'weekly',
                                options: [
                                    {
                                        alias: 'reportAuthorWeeklyQuantity',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'pageView',
                                        type: 'filter_date_indicator',
                                    },
                                    {
                                        alias: 'reportAuthorWeeklyQuantity',
                                        type: 'filter_values',
                                        filterKey: 'weekStartDate',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'author',
                                label: 'Author',
                            },
                            {
                                field: 'articleQuantity',
                                label: 'Article Quantity',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Yazar İçerik Adet İstatistikleri - Aylık',
                description: 'Yazarların, sadece seçilen ay içinde ürettikleri içeriklerin adet ve okunma sayılarını gösterir.',
                queryAlias: 'reportAuthorMonthlyQuantity',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportAuthorMonthlyQuantity',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'monthly',
                                options: [
                                    {
                                        alias: 'reportAuthorMonthlyQuantity',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'pageView',
                                        type: 'filter_date_indicator',
                                    },
                                    {
                                        alias: 'reportAuthorMonthlyQuantity',
                                        type: 'filter_values',
                                        filterKey: 'monthStartDate',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'pageUrlCleanNoProtcol',
                                label: 'URL',
                            },
                            {
                                field: 'author',
                                label: 'Author',
                            },
                            {
                                field: 'articleQuantity',
                                label: 'Article Quantity',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    },
                ],
            },
            {
                title: 'Kategori İstatistikleri - Haftalık',
                description: 'Kategorilerin, seçilen haftaya ait istatistik verilerini gösterir.',
                queryAlias: 'reportBreadcrumbWeekly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportBreadcrumbWeekly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'weekly',
                                options: [
                                    {
                                        alias: 'reportBreadcrumbWeekly',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'category',
                                label: 'Category',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    }],

            },
            {
                title: 'Kategori İstatistikleri - Aylık',
                description: 'Kategorilerin, seçilen aya ait istatistik verilerini gösterir.',
                queryAlias: 'reportBreadcrumbMonthly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportBreadcrumbMonthly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'monthly',
                                options: [
                                    {
                                        alias: 'reportBreadcrumbMonthly',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'category',
                                label: 'Category',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    }],
            },
            {
                title: 'Source İstatistikleri - Haftalık',
                description: 'Source ların, seçilien haftaya ait istatistik verilerini gösterir.',
                queryAlias: 'reportSourceWeekly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportSourceWeekly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'weekly',
                                options: [
                                    {
                                        alias: 'reportSourceWeekly',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'source',
                                label: 'Source',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    }],

            },
            {
                title: 'Source İstatistikleri - Aylık',
                description: 'Source ların, seçilen aya ait istatistik verilerini gösterir.',
                queryAlias: 'reportSourceMonthly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportSourceMonthly',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'monthly',
                                options: [
                                    {
                                        alias: 'reportSourceMonthly',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'source',
                                label: 'Source',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    }],

            },
            {
                title: 'Video İstatistikleri - Günlük',
                description: 'Video ların, seçilen günlere ait istatistik verilerini gösterir.',
                queryAlias: 'reportVideoDaily',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportVideo',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'daily_range',
                                options: [
                                    {
                                        alias: 'reportVideo',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'videoId',
                                label: 'ID',
                            },
                            {
                                field: 'videoLabel',
                                label: 'Label',
                            },
                            {
                                field: 'videoPublishedDate',
                                label: 'Date Published',
                            },
                            {
                                field: 'videoPlayedTimeAvg',
                                label: 'Average Played Time',
                            },
                            {
                                field: 'videoDuration',
                                label: 'Duration',
                            },
                            {
                                field: 'videoPlayCount',
                                label: 'Play Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'videoPlayedTimeTotal',
                                label: 'Play Time Total',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'videoCompleted',
                                label: 'Completed Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    }],
            },
            {
                title: 'Video İstatistikleri - Haftalık',
                description: 'Video ların, seçilen haftaya ait istatistik verilerini gösterir.',
                queryAlias: 'reportVideoWeekly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportVideo',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'weekly',
                                options: [
                                    {
                                        alias: 'reportVideo',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'videoId',
                                label: 'ID',
                            },
                            {
                                field: 'videoLabel',
                                label: 'Label',
                            },
                            {
                                field: 'videoPublishedDate',
                                label: 'Date Published',
                            },
                            {
                                field: 'videoPlayedTimeAvg',
                                label: 'Average Played Time',
                            },
                            {
                                field: 'videoDuration',
                                label: 'Duration',
                            },
                            {
                                field: 'videoPlayCount',
                                label: 'Play Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'videoPlayedTimeTotal',
                                label: 'Play Time Total',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'videoCompleted',
                                label: 'Completed Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    }],
            },
            {
                title: 'Video İstatistikleri - Aylık',
                description: 'Video ların, seçilen aya ait istatistik verilerini gösterir.',
                queryAlias: 'reportVideoMonthly',
                reports: [
                    {
                        title: '',
                        description: '',
                        queryAlias: 'reportVideo',
                        timeout: timeOut,
                        filters: [
                            {
                                type: 'monthly',
                                options: [
                                    {
                                        alias: 'reportVideo',
                                        type: 'limit',
                                        limit: limitSmall,
                                        offset: 0,
                                    },
                                    {
                                        alias: 'cumulative',
                                        type: 'filter_date_indicator',
                                    },
                                ],
                            },
                        ],
                        columns: [
                            {
                                field: 'videoId',
                                label: 'ID',
                            },
                            {
                                field: 'videoLabel',
                                label: 'Label',
                            },
                            {
                                field: 'videoPublishedDate',
                                label: 'Date Published',
                            },
                            {
                                field: 'videoPlayedTimeAvg',
                                label: 'Average Played Time',
                            },
                            {
                                field: 'videoDuration',
                                label: 'Duration',
                            },
                            {
                                field: 'videoPlayCount',
                                label: 'Play Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'pvCount',
                                label: 'PV Count',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'videoPlayedTimeTotal',
                                label: 'Play Time Total',
                                valueFormat: 'numberToLocaleString',
                            },
                            {
                                field: 'videoCompleted',
                                label: 'Completed Count',
                                valueFormat: 'numberToLocaleString',
                            },
                        ],
                    }],
            },
        ]

        return {
            projectId,
            projectBaseId,
            pageLength: 100,
            dir: false,
            pages: ['100', '200'],
            columns: [
                {
                    label: 'Report',
                    field: 'title',
                    sortable: true,
                    hClass: 'page-title-column-th',
                    tdClass: 'text-left align-top page-title-column',
                },
            ],
            reports,
            searchTerm: '',
            reportSettings: null,
        }
    },

    computed: {
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    watch: {
        $route() {
            this.initQueries()
        },
    },
    created() {
        this.initQueries()
    },
    methods: {
        initQueries() {
            const detailsObject = coreApiDetailFilterObject.getFilterDetails()
            if (detailsObject) {
                if (
                    detailsObject.queryAlias
                ) {
                    const settingsList = this.reports.filter(obj => obj.queryAlias === detailsObject.queryAlias)
                    if (settingsList) {
                        const settings = settingsList[0]

                        const filterValues = []

                        if (this.projectId === 'bl8372p22-hs') {
                            filterValues.push({ key: 'projectId', value: 'bl1767ftdlk224' })
                            filterValues.push({ key: 'page_domains', value: 'secim.hurriyet.com.tr' })
                        } else if (this.projectId === 'bl8372p22-ms') {
                            filterValues.push({ key: 'projectId', value: 'bl2ok5med65lk2' })
                            filterValues.push({ key: 'page_domains', value: 'secim.milliyet.com.tr' })
                        } else if (this.projectId === 'bl8372p22-cns') {
                            filterValues.push({ key: 'projectId', value: 'bl8372p22-cn' })
                            filterValues.push({ key: 'page_domains', value: 'secim.cnnturk.com' })
                        } else if (this.projectId === 'bl8372p22-psts') {
                            filterValues.push({ key: 'projectId', value: 'bl8372p22-ps' })
                            filterValues.push({ key: 'page_domains', value: 'secim.posta.com.tr' })
                        } else if (this.projectId === 'bl8372p22-gvs') {
                            filterValues.push({ key: 'projectId', value: 'bl8372p22-gv' })
                            filterValues.push({ key: 'page_domains', value: 'secim.gazetevatan.com' })
                        } else if (this.projectId === 'bl1767ftdlk224-ho') {
                            filterValues.push({ key: 'projectId', value: 'bl1767ftdlk224' })
                            filterValues.push({ key: 'page_domains', value: 'www.hurriyet.com.tr' })
                        } else if (this.projectId === 'bl1767ftdlk224-hbo') {
                            filterValues.push({ key: 'projectId', value: 'bl1767ftdlk224' })
                            filterValues.push({ key: 'page_domains', value: 'bigpara.hurriyet.com.tr,mbigpara.hurriyet.com.tr' })
                        } else if (this.projectId === 'bl2ok5med65lk2-mo') {
                            filterValues.push({ key: 'projectId', value: 'bl2ok5med65lk2' })
                            filterValues.push({ key: 'page_domains', value: 'www.milliyet.com.tr,m.milliyet.com.tr' })
                        } else if (this.projectId === 'bl2ok5med65lk2-muo') {
                            filterValues.push({ key: 'projectId', value: 'bl2ok5med65lk2' })
                            filterValues.push({ key: 'page_domains', value: 'uzmanpara.milliyet.com.tr,uzmanparam.milliyet.com.tr' })
                        } else {
                            filterValues.push({ key: 'projectId', value: this.projectId })
                        }

                        settings.reports.forEach((querySetting, queryIndex) => {
                            let query = {
                                timeout: querySetting.timeout,
                                request_nodes: [
                                    {
                                        project_id: this.projectBaseId,
                                        alias: querySetting.queryAlias,
                                        options: [
                                            {
                                                alias: querySetting.queryAlias,
                                                return_id: 'data',
                                                filter_values: filterValues,
                                            },
                                        ],
                                    },
                                ],
                            }

                            if (querySetting.filters) {
                                querySetting.filters.forEach(filter => {
                                    if (filter.type === 'daily') {
                                        filter.options.forEach(option => {
                                            if (option.type === 'filter_date_indicator') {
                                                const pageTimeFilter = coreApiPageDateFilterObject.getFilterQueryObject()
                                                query = this.queryFilterUpdate(query, option, pageTimeFilter)
                                            } else if (option.type === 'filter_date_indicator_1') {
                                                const pageTimeFilter = coreApiPageDateFilterObject.getFilterQueryObject()
                                                pageTimeFilter.skip += 1
                                                query = this.queryFilterUpdate(query, option, pageTimeFilter)
                                            } else if (option.type === 'filter_date_indicator_7') {
                                                const pageTimeFilter = coreApiPageDateFilterObject.getFilterQueryObject()
                                                pageTimeFilter.skip += 7
                                                query = this.queryFilterUpdate(query, option, pageTimeFilter)
                                            } else if (option.type === 'filter_values') {
                                                const date = coreApiPageDateFilterObject.getFilterQueryObjectDate()
                                                if (date) {
                                                    query = this.queryFilterUpdate(query, option, date)
                                                }
                                            } else if (option.type === 'limit') {
                                                query = this.queryFilterUpdate(query, option, { limit: option.limit, offset: option.offset || 0 })
                                            }
                                        })
                                    }
                                    if (filter.type === 'daily_range') {
                                        filter.options.forEach(option => {
                                            if (option.type === 'filter_date_indicator') {
                                                const pageTimeFilter = coreApiPageDateRangeFilterObject.getFilterQueryObject()
                                                query = this.queryFilterUpdate(query, option, pageTimeFilter)
                                            } else if (option.type === 'filter_values') {
                                                const date = coreApiPageDateRangeFilterObject.getFilterQueryObjectDate()
                                                if (date) {
                                                    query = this.queryFilterUpdate(query, option, date)
                                                }
                                            } else if (option.type === 'limit') {
                                                query = this.queryFilterUpdate(query, option, { limit: option.limit, offset: option.offset || 0 })
                                            }
                                        })
                                    }
                                    if (filter.type === 'weekly') {
                                        filter.options.forEach(option => {
                                            if (option.type === 'filter_date_indicator') {
                                                const pageTimeFilter = coreApiPageWeekFilterObject.getFilterQueryObject()
                                                query = this.queryFilterUpdate(query, option, pageTimeFilter)
                                            } else if (option.type === 'filter_date_indicator_1') {
                                                const pageTimeFilter = coreApiPageWeekFilterObject.getFilterQueryObject()
                                                pageTimeFilter.skip += 1
                                                query = this.queryFilterUpdate(query, option, pageTimeFilter)
                                            } else if (option.type === 'filter_values') {
                                                const weekDate = coreApiPageWeekFilterObject.getFilterQueryObjectDate()
                                                if (weekDate) {
                                                    query = this.queryFilterUpdate(query, option, weekDate)
                                                }
                                            } else if (option.type === 'limit') {
                                                query = this.queryFilterUpdate(query, option, { limit: option.limit, offset: option.offset || 0 })
                                            }
                                        })
                                    }
                                    if (filter.type === 'monthly') {
                                        filter.options.forEach(option => {
                                            if (option.type === 'filter_date_indicator') {
                                                const pageTimeFilter = coreApiPageMonthFilterObject.getFilterQueryObject()
                                                query = this.queryFilterUpdate(query, option, pageTimeFilter)
                                            } else if (option.type === 'filter_date_indicator_1') {
                                                const pageTimeFilter = coreApiPageMonthFilterObject.getFilterQueryObject()
                                                pageTimeFilter.skip += 1
                                                query = this.queryFilterUpdate(query, option, pageTimeFilter)
                                            } else if (option.type === 'filter_values') {
                                                const monthDate = coreApiPageMonthFilterObject.getFilterQueryObjectDate()
                                                if (monthDate) {
                                                    query = this.queryFilterUpdate(query, option, monthDate)
                                                }
                                            } else if (option.type === 'limit') {
                                                query = this.queryFilterUpdate(query, option, { limit: option.limit, offset: option.offset || 0 })
                                            }
                                        })
                                    }
                                })
                            }
                            settings.reports[queryIndex].executeQuery = query

                            executeQuery(
                                coreApiDataIndex[`d${queryIndex + 1}`],
                                query,
                            )
                        })
                        this.reportSettings = settings
                    }
                }
            } else {
                this.reportSettings = null
            }
        },
        queryFilterUpdate(query, filterOption, value) {
            let queryOptionIndex = false
            query.request_nodes[0].options.forEach((option, index) => {
                if (option.alias === filterOption.alias) {
                    queryOptionIndex = index
                }
            })

            let option = {}
            switch (filterOption.type) {
            case 'filter_date_indicator':
            case 'filter_date_indicator_1':
            case 'filter_date_indicator_7':
                option.alias = filterOption.alias
                option.filter_date_indicator = value
                break
            case 'filter_values':
                option.alias = filterOption.alias
                option.filter_value_list = []

                filterOption.filterKey.split('|').forEach((filterKey, index) => {
                    let currentValue = value
                    if (typeof value === 'object') {
                        currentValue = Object.values(value)[index]
                    }
                    option.filter_value_list.push({ key: filterKey, value: currentValue })
                })
                break
            case 'limit':
                option.alias = filterOption.alias
                option.limit = filterOption.limit
                option.offset = filterOption.offset
                break
            default:
                option = null
                break
            }

            if (option) {
                if (queryOptionIndex !== false) {
                    if (option.filter_value_list) {
                        if (!query.request_nodes[0].options[queryOptionIndex].filter_values) {
                            // eslint-disable-next-line no-param-reassign
                            query.request_nodes[0].options[queryOptionIndex].filter_values = []
                        }

                        const filterValueAdded = {}
                        option.filter_value_list.forEach(filterValue => {
                            filterValueAdded[filterValue.key] = false
                        })
                        query.request_nodes[0].options[queryOptionIndex].filter_values.forEach((existOption, existOptionIndex) => {
                            option.filter_value_list.forEach(filterValue => {
                                if (existOption.key === filterValue.key) {
                                    // eslint-disable-next-line no-param-reassign
                                    query.request_nodes[0].options[queryOptionIndex].filter_values[existOptionIndex].value = filterValue.value
                                    filterValueAdded[filterValue.key] = true
                                }
                            })
                        })

                        // eslint-disable-next-line no-restricted-syntax
                        for (const [key, isAdded] of Object.entries(filterValueAdded)) {
                            if (!isAdded) {
                                // eslint-disable-next-line no-loop-func
                                option.filter_value_list.forEach(filterValue => {
                                    if (filterValue.key === key) {
                                        query.request_nodes[0].options[queryOptionIndex].filter_values.push(filterValue)
                                    }
                                })
                            }
                        }
                    }

                    if (
                        option.filter_date_indicator
                    ) {
                        // eslint-disable-next-line no-param-reassign
                        query.request_nodes[0].options[queryOptionIndex].filter_date_indicator = option.filter_date_indicator
                    }
                    if (
                        option.limit
                    ) {
                        // eslint-disable-next-line no-param-reassign
                        query.request_nodes[0].options[queryOptionIndex].limit = option.limit
                        // eslint-disable-next-line no-param-reassign
                        query.request_nodes[0].options[queryOptionIndex].offset = option.offset
                    }
                } else {
                    query.request_nodes[0].options.push(option)
                }
            }

            return query
        },
        getReportData(index) {
            return this[`reportData${index}`]
        },
        getReportDataOnProgress(index) {
            return this[`reportDataOnProgress${index}`]
        },
        handleSearch(searching) {
        },
        handleChangePage(page) {
        },
        handlePageChange(active) {
        },
        onSortChange(params) {
        },
        searchTable(row, col, cellValue, searchTerm) {
            return !searchTerm ? true : (row.videoId && row.videoId.includes(searchTerm))
                || (row.videoLabel && row.videoLabel.includes(searchTerm))
        },
        isMobile() {
            return window.innerWidth < 768
        },
        reportSelected(settings) {
            const filters = { details: { queryAlias: settings.queryAlias } }
            const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
            if (newPath !== this.$route.fullPath) {
                this.$router.push(newPath)
            }
        },
        closeReport() {
            window.location.hash = ''
            this.reportSettings = null
        },
    },
    setup() {
        return {
            reportData0: getCoreApiData(coreApiDataIndex.d1),
            reportDataOnProgress0: getCoreApiDataOnProgress(coreApiDataIndex.d1),
            reportData1: getCoreApiData(coreApiDataIndex.d2),
            reportDataOnProgress1: getCoreApiDataOnProgress(coreApiDataIndex.d2),
            reportData2: getCoreApiData(coreApiDataIndex.d3),
            reportDataOnProgress2: getCoreApiDataOnProgress(coreApiDataIndex.d3),
            reportData3: getCoreApiData(coreApiDataIndex.d4),
            reportDataOnProgress3: getCoreApiDataOnProgress(coreApiDataIndex.d4),
        }
    },
}
</script>

<style lang="scss" >
@import '~@core/scss/vue/libs/vue-good-table.scss';
</style>
